<template>
  <div>
    <template v-if="!loading">
      <b-row align-v="center">
        <b-col lg="4">
          <b-row align-v="center">
            <b-col cols="8" lg="12">
              <h6 class="h6-semibold-azure-uppercase">{{ current.pad(2) }}</h6>
              <h3 class="h3-semibold-black">I tuoi consumi</h3>
              <p class="p-medium-gray-600 p-mobile-small">
                Se non compili i valori, verranno utilizzati i consumi previsti dall’AREA per un cliente tipo (2700
                kWh/Anno
                e 1400 mc/Anno)
              </p>
            </b-col>

            <b-col cols="4" lg="12" v-if="isMobile" class="mb-4">
              <div class="icon">
                <img src="img/icone/SGR-Icons-Consumi.svg">
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4">
          <b-form-group
              label="Quanto consumi all’anno in Energia elettrica"
              label-for="field1"
              :state="states.luce"
          >
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <div class="input-group-text">kWh/anno</div>
              </div>
              <b-form-input id="field1" v-model="localOptions.consumi.luce"
                            placeholder="Es: 2700" type="number"
                            class="form-control-gray-900"></b-form-input>
            </div>
          </b-form-group>

          <b-form-group
              label="Quanto consumi all’anno in Gas Naturale"
              label-for="field2"
              :state="states.gas"
          >
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <div class="input-group-text">Smc/anno</div>
              </div>
              <b-form-input id="field2" v-model="localOptions.consumi.gas"
                            placeholder="Es: 1400" type="number"
                            class="form-control-gray-900"></b-form-input>
            </div>
          </b-form-group>

        </b-col>
        <b-col lg="3" offset-lg="1" class=" text-center lg:text-right">
          <div class="icon" v-if="!isMobile">
            <img src="img/icone/SGR-Icons-Consumi.svg">
          </div>
          <button @click="nextStep" class="button-azure-rounded mt-2 lg:mt-8 px-8">Avanti</button>
        </b-col>
      </b-row>
    </template>
  </div>

</template>

<script>
export default {
  name: 'Step-2',
  data() {
    return {
      thisStep: 2,
      localOptions: null,
      loading: true,
      states: {},
    }
  },
  props: {
    steps: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      default: 1,
    },
    options: {
      type: [Array, Object],
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  created() {
    if (this.options.step < this.thisStep) this.$router.push({name: 'step-1'})
    this.$emit('setCurrent', this.thisStep)
    this.localOptions = {...this.options};
    this.loading = false;

    if(typeof this.$analytics != 'undefined') {
      this.trackFbViewContent('check-up-energetico', 'step-2');
    }
  },
  methods: {
    nextStep() {
      let that = this;
      let valid = true;
      that.states = {};
      let luceVal = this.localOptions.consumi.luce;
      let gasVal = this.localOptions.consumi.gas;
      if(luceVal === null || luceVal === '') this.localOptions.consumi.luce = 2700;
      if(gasVal === null || gasVal === '') this.localOptions.consumi.gas = 1400;
      for (const [key, value] of Object.entries(that.localOptions.consumi)) {
        if (value === null || value === '') {
          that.states[key] = true;
          valid = false;
        }
      }
      if (valid) this.$emit('nextStep', this.thisStep + 1, this.localOptions)
    }
  },
}
</script>

<style scoped lang="scss">
</style>